module.exports = "/_next/static/images/favicon-57cba0ffe748ef5f82e24cc770a5fe32.png";